import {Component, Input, OnInit} from '@angular/core';
import {IdName} from '@core/src/public-api';
import {diaryEventPeriodicityTypeCodes} from '@shared/constants/diary.constants';
import {DiaryEventPeriodicity} from '@shared/models/diary.model';
import * as moment from 'moment';

@Component({
  selector: 'si-med-medication-item',
  templateUrl: './med-medication-item.component.html',
  styleUrls: ['./med-medication-item.component.scss']
})
export class MedMedicationItemComponent implements OnInit {
  @Input() medicationId: number;
  @Input() title: string;
  @Input() activeIngredient: string;
  @Input() quantity: string;
  @Input() unit: string;
  @Input() dosageSchedule: string;
  @Input() periodicityType: IdName;
  @Input() periodicity: DiaryEventPeriodicity;
  @Input() initDate: number;
  @Input() observations: string;
  isPast: boolean;
  isCurrent: boolean;
  isFuture: boolean;
  stateText: string;
  diaryEventPeriodicityTypeCodes = diaryEventPeriodicityTypeCodes;

  ngOnInit(): void {
    this.calculateMedicationState();
  }

  calculateMedicationState(): void {
    const startOfToday = moment().startOf('day').valueOf();
    const endOfToday = moment().endOf('day').valueOf();
    const endDate = (this.periodicityType.code == diaryEventPeriodicityTypeCodes.NO_REPEAT) ? this.initDate : this.periodicity.finalDate;

    if (!endDate) {
      if (this.initDate > endOfToday) {
        this.isFuture = true;
        this.stateText = 'SI_NOT_STARTED_F';
      } else {
        this.isCurrent = true;
        this.stateText = 'SI_STARTED_F';
      }
    } else {
      if (endDate < startOfToday) {
        this.isPast = true;
        this.stateText = 'SI_FINISHED_F';
      } else if (this.initDate > endOfToday) {
        this.isFuture = true;
        this.stateText = 'SI_NOT_STARTED_F';
      } else {
        this.isCurrent = true;
        this.stateText = 'SI_STARTED_F';
      }
    }
  }
}
